module.exports = __webpack_public_path__ + "static/media/card.a10bb925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/houston/card.jpg
// module id = 871
// module chunks = 27